import { sendAjaxDataToWP } from "./sendAjaxDataToWP";
import { delay } from "./Utils";
import { createToast } from "./Toast";

const CreateSkillCategory = (modal) => {
  // if the form exists
  const form = document.getElementById("create_skill_category_form");
  const spinner = form.querySelector("button[type=submit] svg");
  const spinnerText = form.querySelector("button[type=submit] span");

  if (form) {
    form.addEventListener("submit", (ev) => {
      ev.preventDefault();

      // show ui
      spinner.classList.remove("hidden!");
      spinnerText.textContent = "Saving...";

      // add data to form
      const data = new FormData(form);
      data.append("action", "create_skill_category");
      //console.log([...data]);

      // perform action
      sendAjaxDataToWP(data)
        .then((result) => {
          if (result) {
            //console.log("Data received from server:", result);
          }
          delay(1000).then(() => {
            spinner.classList.add("hidden!");
            spinnerText.textContent = "Save";
            createToast({
              type: "success",
              message: result.message,
              duration: 1000,
              url: "/skills",
            });
            modal.hide();
          });
        })
        .catch((error) => {
          console.error("Global Error Handler:", error);
          spinner.classList.add("hidden!");
          spinnerText.textContent = "Save";
          createToast({
            type: "error",
            message: "System Error!",
            duration: 1000,
          });
        });
    });
  }
};

export { CreateSkillCategory };
